export default __webpack_public_path__ + "static/media/category_t1.75c6ea86.svg";